import $ from "jquery";

$(function initialize() {
  $(document).on('change', '[data-behavior="file-input"] input', function handleChange() {
    var $hiddenInput = $(this);
        var labelValue   = $hiddenInput.val().replace(/^.*\\/, "") || 'Select a file';

    $hiddenInput.siblings('.filename').text(labelValue);
  });
});
